module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    attrs: {
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": _vm.guts
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('text-input', {
    attrs: {
      "label": "Name",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.row.name),
      callback: function($$v) {
        _vm.$set(_vm.row, "name", $$v)
      },
      expression: "row.name"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('number-input', {
    attrs: {
      "label": "Users",
      "min": 1,
      "max": 10,
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.row.users),
      callback: function($$v) {
        _vm.$set(_vm.row, "users", $$v)
      },
      expression: "row.users"
    }
  })], 1), _vm._v(" "), _c('h4', [_vm._v("User Rates")]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": _vm.guts
    }
  }, _vm._l((Number(_vm.row.users)), function(i) {
    return _c('el-col', {
      key: i,
      attrs: {
        "xs": 24,
        "sm": 12,
        "md": 6,
        "lg": 4
      }
    }, [_c('number-input', {
      attrs: {
        "label": 'Rate #' + i,
        "suffix": "%",
        "disabled": _vm.disabled
      },
      model: {
        value: (_vm.row['telco' + i]),
        callback: function($$v) {
          _vm.$set(_vm.row, 'telco' + i, $$v)
        },
        expression: "row['telco' + i]"
      }
    })], 1)
  }), 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": _vm.guts
    }
  }, [_c('hr'), _vm._v(" "), _c('h4', [_vm._v("Cabin & Outdoor Rates")])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": _vm.guts
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 6
    }
  }, [_c('integer-input', {
    attrs: {
      "label": "Cabin Qty.",
      "min": 0,
      "max": 10,
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.row.cabin),
      callback: function($$v) {
        _vm.$set(_vm.row, "cabin", $$v)
      },
      expression: "row.cabin"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 6
    }
  }, [_c('integer-input', {
    attrs: {
      "label": "Cabin Rate",
      "min": 0,
      "max": 100,
      "suffix": "%",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.row.cabinRate),
      callback: function($$v) {
        _vm.$set(_vm.row, "cabinRate", $$v)
      },
      expression: "row.cabinRate"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 6
    }
  }, [_c('integer-input', {
    attrs: {
      "label": "Outdoor Qty.",
      "min": 0,
      "max": 10,
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.row.outdoor),
      callback: function($$v) {
        _vm.$set(_vm.row, "outdoor", $$v)
      },
      expression: "row.outdoor"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 6
    }
  }, [_c('integer-input', {
    attrs: {
      "label": "Outdoor Rate",
      "min": 0,
      "max": 100,
      "suffix": "%",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.row.outdoorRate),
      callback: function($$v) {
        _vm.$set(_vm.row, "outdoorRate", $$v)
      },
      expression: "row.outdoorRate"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": _vm.guts
    }
  }, [_c('hr'), _vm._v(" "), _c('h4', [_vm._v("MW & RRU Rates")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('currency-input', {
    attrs: {
      "label": "MW Rate",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.row.mwRate),
      callback: function($$v) {
        _vm.$set(_vm.row, "mwRate", $$v)
      },
      expression: "row.mwRate"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('currency-input', {
    attrs: {
      "label": "RRU Rate",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.row.rruRate),
      callback: function($$v) {
        _vm.$set(_vm.row, "rruRate", $$v)
      },
      expression: "row.rruRate"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('number-input', {
    attrs: {
      "label": "RRU Set",
      "min": 0,
      "max": 10,
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.row.rruSet),
      callback: function($$v) {
        _vm.$set(_vm.row, "rruSet", $$v)
      },
      expression: "row.rruSet"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d6cff62"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/finance/rates/actions/UtilityRateDetails.vue
// module id = 1660
// module chunks = 0